/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_staff': {
    width: 26,
    height: 29,
    viewBox: '0 0 26 29',
    data: '<path pid="0" d="M13 21l-4.5-5.5M13 21l4.5-5.5M13 21l5.5-1-1-4.5M13 21l-5.5-1 1-4.5m0 0c-3.107.094-4.217.217-5.5 1.5-1.757 1.757-1.5 4.343-1.5 10v1.5h23V27c0-5.657.257-8.243-1.5-10-1.283-1.283-2.393-1.406-5.5-1.5m-2.5 8h5M19.5 7a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_staff.js